import { FormElement } from "./FormElement";
import { DOMTemplate } from "../../denki";
import { node } from "../Util";
import { FieldInputElement } from "./FieldInputElement";
import { OptionType } from "../definition/OptionType";

export class FormSelectElement extends FormElement implements FieldInputElement {
  public readonly fieldsElement: HTMLElement;
  public readonly selectElement: HTMLSelectElement;
  public readonly prefixElement: HTMLLabelElement;
  public readonly suffixElement: HTMLLabelElement;
  public validator?: (text: string) => Promise<string[]> | string[];
  private readonly map: { [key: string]: HTMLInputElement } = {};

  constructor(name: string, options: OptionType[], template: DOMTemplate) {
    super(name, template.get("field-element"));
    this.fieldsElement = this.element.querySelector("[data-role=elements]");
    this.prefixElement = node("label", {}, "");
    this.suffixElement = node("label", {}, "");
    const id = name;
    const select = <HTMLSelectElement>node('select', { id });
    for (let i = 0, l = options.length; i < l; i++) {
      const option = options[i];
      const [value, label] = (() => {
        if (typeof option === "string") {
          return [option, option];
        } else {
          return [option.value, option.label];
        }
      })();
      const optionName = `${name}-${value}`;
      const elementId = optionName;
      select.appendChild(node('option', {
        'data-id': elementId,
        'data-name': optionName,
        value
      }, label));
    }
    select.selectedIndex = 0;
    this.value = select.value;
    select.addEventListener("change", e => {
      this.value = select.value;
    });
    this.virtualInput.addEventListener("change", () => {
      select.value = this.value;
    });
    this.virtualInput.setAttribute("data-id", id);
    this.virtualInput.setAttribute("name", id);
    this.selectElement = select;
    this.fieldsElement.appendChild(this.prefixElement);
    this.fieldsElement.appendChild(select);
    this.fieldsElement.appendChild(this.suffixElement);
    /*
    初期値をthis.value経由でセットするせいで、バリデータなしで一度非同期バリデーション処理が実行され、
    completedマークが表示されるので、setTimeoutで非同期バリデーション実行後にcompletedマークを消す
    */
    setTimeout(() => {
      this.titleElement.classList.remove("completed");
    });
  }

  public get mapKeys(): string[] {
    return Object.keys(this.map);
  }

  public focus() {
    this.selectElement.focus();
  }

  get validationErrors(): Promise<string[]> {
    const validator = this.validator;
    if (!validator) return Promise.resolve([]);
    return Promise.resolve(validator(String(this.value)));
  }
}